import { TIER_LIMIT_KEYS, TierCatalogEntry } from "@/types/api/tiers";
import { monitoringCaptureError } from "@/plugins/monitoring";
import { sdk } from "@/js/sdk";

const TIER_CATALOG_TRANSACTION = "Fetch tier catalog";

function reportLimitShapeMismatches(catalog: TierCatalogEntry[]): void {
	const servedPerTier = catalog.map((entry) => Object.keys(entry?.Limits ?? {}));

	const unknownKeys = [...new Set(servedPerTier.flat())].filter((key) => !TIER_LIMIT_KEYS.includes(key));
	if (unknownKeys.length > 0) {
		monitoringCaptureError(
			new Error(`Tier catalog served unknown limits: ${unknownKeys.join(", ")}`),
			TIER_CATALOG_TRANSACTION,
		);
	}

	const droppedKeys = TIER_LIMIT_KEYS.filter((key) => servedPerTier.some((servedKeys) => !servedKeys.includes(key)));
	if (droppedKeys.length > 0) {
		monitoringCaptureError(
			new Error(`Tier catalog stopped serving limits: ${droppedKeys.join(", ")}`),
			TIER_CATALOG_TRANSACTION,
		);
	}
}

export async function getTiers(): Promise<TierCatalogEntry[]> {
	const catalog = await sdk.tiers.list();

	if (!Array.isArray(catalog)) {
		throw new Error("Tier catalog response was not a list of tiers");
	}

	reportLimitShapeMismatches(catalog);

	return catalog;
}
